module.exports = __webpack_public_path__ + "media/51.362e8797.wav";